export const LIGHT_THEME = 'light';
export const DARK_THEME = 'dark';
export const TIGO_THEME = 'tigo';

export const APP_STORE = 'appStore';
export const GOOGLE_PLAY_STORE = 'googlePlay';

export const ENV_PROD = 'prod';
export const ENV_STAGE = 'stage';

export const CHANNEL_MESSAGING = 'messaging';

export enum TYPES_ATTACHMENT {
  'image' = 'image',
  'video' = 'video',
  'remittance' = 'remittance',
  'request_remittance' = 'request_remittance',
  'document' = 'document',
}

export const REQUEST_REMITTANCE = 'request';
export const SEND_REMITTANCE = 'send';

export const CHAT_OWNER_TYPE = 'owner';
export const CHAT_MEMBER_TYPE = 'member';

export const FIELD_FIRST_NAME = 'firstName';
export const FIELD_MIDDLE_NAME = 'middleName';
export const FIELD_FIRST_LAST_NAME = 'firstLastName';
export const FIELD_SECOND_LAST_NAME = 'secondLastName';
export const FIELD_BIRTHDATE = 'birthdate';
export const FIELD_CITY = 'city';
export const FIELD_PROVINCE = 'province';
export const FIELD_FULL_NAME = 'fullName';
export const FIELD_PHONE_NUMBER = 'phoneNumber';
export const FIELD_REQUEST_AMOUNT = 'requestAmount';
export const FIELD_CODE_REMITTANCE = 'codeRemittance';
export const FIELD_DESCRIPTION = 'description';
export const TOPII_TERMS = 'https://stage.api.chapii.com/api/v1/static_html/user/en/terms_and_conditions/?country_code=US&theme=light'
export const TOPII_POLICY = 'https://stage.api.chapii.com/api/v1/static_html/user/en/privacy_and_policies/?country_code=US&theme=light'
  export const BUCKZY_TERMS = 'https://stage.api.chapii.com/api/v1/static_html/remittance/terms_and_conditions/?country_code=US&theme=light'
export const BUCKZY_POLICY = 'https://stage.api.chapii.com/api/v1/static_html/remittance/privacy_and_policies/?country_code=US&theme=light'
